export const SKIP_TO_MAIN = 'Skip to Main'
